import { Session } from './session';
import { Participation } from './participation';
import { useMutation } from 'react-query';
import { queryCreate } from './fetch';
import { AxiosError } from 'axios';
import { SelectionPayload } from './participations/selection';

export enum EvaluationType {
  PARTICIPATION = 'PARTICIPATION',
  SESSION = 'SESSION',
}

export interface Evaluation {
  id: string;
  type: EvaluationType;
  message?: string;
  score: number;
  sessionId?: string;
  participationId?: string;
  session?: Session;
  participation?: Participation;
}

interface CreateEvaluation {
  message?: string;
  score?: number;
}

interface CreateBulkEvaluation extends SelectionPayload {
  score: number;
  message?: string;
}

export const useCreateEvaluationSession = (sessionId: string) => {
  return useMutation<CreateEvaluation, AxiosError, CreateEvaluation>(
    queryCreate(`/sessions/${sessionId}/evaluations`),
  );
};

export const useCreateEvaluationParticipation = (participationId: string) => {
  return useMutation<CreateEvaluation, AxiosError, CreateEvaluation>(
    queryCreate(`/participations/${participationId}/evaluations`),
  );
};

export const useBulkCreateEvaluation = (sessionId: string) => {
  return useMutation<Evaluation[], AxiosError, CreateBulkEvaluation>(
    ({ selectedParticipations, ...data }) =>
      queryCreate(`/sessions/${sessionId}/participations/evaluate`)(data),
  );
};

export const useCreateDefaultEvaluationParticipation = () => {
  return useMutation<CreateEvaluation, AxiosError, Participation>(
    (participation: Participation) =>
      queryCreate(`/participations/${participation.id}/evaluations`)({
        score: 100,
      }),
  );
};
